import EntidadService from '@/services/entidad.service'
export const namespaced = true

export const actions = {
  fetchEntidad(context, payload) {
    let params = 'params' in payload ? payload.params : null
    return EntidadService.getEntidad(payload.jwt, params)
  },
  addEntidad(context, payload) {
    return EntidadService.postEntidad(payload.jwt, payload.body)
  },
  editEntidad(context, payload) {
    return EntidadService.putEntidad(payload.jwt, payload.body, payload.id)
  },
  deleteEntidad(context, payload) {
    return EntidadService.deleteEntidad(payload.jwt, payload.body, payload.id)
  },
}
